import React from 'react';
import MatLogPackageUpsert from './components/MatLogPackageUpsert';

const MatLogPackageCreate: React.FC = () => {
  return <MatLogPackageUpsert mode="create" />;
};

export default MatLogPackageCreate;

